/**
 * @generated SignedSource<<72780697d815ba0b47ba06abfcdb06a9>>
 * @relayHash 54a5106deb8051638f67e17262ef90b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ae8f1aadd164d1b501e16f6020a287594e642feab79c3afc381daad3acbf576

import type { ConcreteRequest } from 'relay-runtime';
export type useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$variables = Record<PropertyKey, never>;
export type useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$data = {
  readonly license: {
    readonly licenseConsumingUserCount: number;
  } | null | undefined;
};
export type useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery = {
  response: useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$data;
  variables: useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "License",
    "kind": "LinkedField",
    "name": "license",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "licenseConsumingUserCount"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "54a5106deb8051638f67e17262ef90b5",
    "id": "1ae8f1aadd164d1b501e16f6020a287594e642feab79c3afc381daad3acbf576",
    "metadata": {},
    "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
    "operationKind": "query",
    "text": "query useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery{license{licenseConsumingUserCount}}"
  }
};
})();

(node as any).hash = "eaf07b0d0888b09c16c5bc48d9bf826d";

export default node;
